import type { TodayIncome } from '@/types/api';

// Легаси-кабинет показывал в шапке одно рублёвое число ({{me.today_sum}} ₽).
// Новый /me отдаёт today_incomes массивом по валютам — берём рублёвую строку
// (по currency.ico/name), иначе первую. Возвращаем income_total числом.
// На пустой массив/отсутствие — 0 (денежное поле, лучше 0.00 чем «нет данных»).
export const pickTodayIncomeTotal = (incomes?: TodayIncome[] | null): number => {
  if (!incomes?.length) return 0;
  const rub = incomes.find((i) => {
    const ico = i.currency?.ico ?? '';
    const name = i.currency?.name ?? '';
    return ico.includes('₽') || /руб|rub/i.test(name);
  });
  const total = (rub ?? incomes[0]).income_total;
  const num = typeof total === 'number' ? total : Number.parseFloat(total);
  return Number.isNaN(num) ? 0 : num;
};
